module.exports = __webpack_public_path__ + "img/logo.a389c7fb.svg";